'use strict';

let domine;
let iframe;
let interval;

/**
 * Handles messages received from the iframe.
 * @param {MessageEvent} event - The message event.
 * version 1.3
 */
const handleMessage = (event) => {
  window.addEventListener('message', (event) => {
    if (event.data.type === 'NGX_LOADING_COMPLETE') {
      clearInterval(interval);
    }
  });
}

/**
 * Prepares and inserts an iframe into the specified container.
 * @param {Object} params - The parameters for the iframe.
 * @param {string} params.urlDomine - The base URL for the iframe.
 * @param {string} params.uri - The URI to append to the base URL.
 * @param {string} params.containerId - The ID of the container element.
 * @param {boolean} [params.sportsbooks_integration] - Flag for sportsbook integration.
 * @param {number} [params.reducePixel] - Reduce screen height by x pixels.
 */
const prepareFrame = (params = {}) => {

  domine = params.urlDomine;
  window.addEventListener('message', handleMessage, false);

  const container = window.document.getElementById(params.containerId);

  if (!container) {
    throw new Error('!!!Could not find container!!!');
  }

  iframe = document.createElement('iframe');
  iframe.setAttribute('src', `${params.urlDomine}/sportsbook-integration`);
  iframe.style.width = '100%';
  iframe.style.height = `${window.innerHeight - (Number(params.reducePixel || 0))}px`;
  iframe.onload = () => {
    params.sportsbooks_integration = true;

    interval = setInterval(() => {
      iframe.contentWindow.postMessage(params, `${params.urlDomine}/sportsbook-integration`);
    }, 2000);
  };
  container.appendChild(iframe);
}

const updateFrame = (params = {}) => {
  iframe.contentWindow.postMessage(params, `${domine}/sportsbook-integration`);
}

/**
 * Initializes the iframe with the given parameters.
 * @param {Object} params - The parameters for initialization.
 */
export const initialize = (params = {}) => {
  prepareFrame(params);
}

export const update = (params = {}) => {

  if(params){
    params.sportsbooks_integration_update = true;
    updateFrame(params);
  } else {
    throw new Error('!!!Params undefined!!!');
  }
}

window.sportsbooks = {
  initialize,
  update
};

